import { render, staticRenderFns } from "./addSubCourse.vue?vue&type=template&id=bfc9bba2&scoped=true&"
import script from "./addSubCourse.vue?vue&type=script&lang=js&"
export * from "./addSubCourse.vue?vue&type=script&lang=js&"
import style0 from "./addSubCourse.vue?vue&type=style&index=0&id=bfc9bba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc9bba2",
  null
  
)

export default component.exports